import React, { useContext, useEffect, useState } from 'react'

//styles
import './ListCardComponent.css'
import { getAllCards, getAllCardsInventary, getAllCardsInventaryPublic } from '../../Api/Cards'
import { Inventary } from '../../Models/Inventary'
import { PokemonCard } from '../../Models/PokemonCard'
import { Pagination, Spin } from 'antd'
import SkeletonCart from '../Skeleton/SkeletonCart'
import { PromiseSesionContext } from '../../Machines/ErrorMachine'
import FilterSectionPokemon from '../FilterSectionCards/FilterSectionPokemon'
import NewCardsCountdown from '../NewCardsCountdown/NewCardsCountdown'
import { useDebounce } from '../../Hooks/useDebounce'
import { Monitor } from '../../Models/Monitor'
import { addMonitor } from '../../Api/Monitor'
import SideBarComponent from '../../Components/SideBarComponent/SideBarComponent'
import CardAdminComponentPokemon from '../CardComponentPokemon/CardAdminComponentPokemon'
interface Props{
    propsStyles?: React.CSSProperties,
    elementClass?: string
    type: "inventary" | "all" | "cards"
    subType: "Private" | "Public"

    setID?:string

    //functions props
    hasQty?: boolean
    hasCart?:boolean
    qtyFunction?: (qty:number) => void

    hasPrice?: boolean

    onClick?: (pokemonCard:PokemonCard) => void
    onClickIventary?: (iventary:Inventary) => void


}

const ListCardAdminComponentPokemon = ({propsStyles, onClick, elementClass, hasQty, qtyFunction, hasPrice, type, onClickIventary, hasCart, setID, subType}:Props) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const {sendError} = useContext(PromiseSesionContext);
  const [inventary, setInventary] = React.useState<Inventary[]>([]);
  const [filterInventary, setFilterInventary] = React.useState<Inventary[]>([]);

  const [allCards, setAllCards] = React.useState<PokemonCard[]>([]);

  const [errorView,setErrorView] = React.useState<string>("");
  const [nameCards, setNameCard] = React.useState<string>("");
  const [selectedSets, setSelectedSets] = useState<string[]>([]);
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  // const debouncedNameCards = useDebounce(nameCards, 700);
  // const debouncedSetsCards = useDebounce(selectedSets, 700);
  // const debouncedRarityCards = useDebounce(selectedTypes, 700);


    //paginate
    const [page, setPage] = useState<number>(1)
    const [limitPage, setLimitPage] = useState<number>(30)
    const sizePages = 48

    const [totalPage, setTotalPage] = useState<number>(0)
    const [totalElements, setTotalElements] = useState<number>(0)


  const getAllInventary = async () => {
    try{
      setLoading(true);

      const response = subType==="Public" ? await getAllCardsInventaryPublic(page, limitPage, nameCards, selectedSets.join(","), selectedTypes.join(",")) : await getAllCardsInventary();
      // console.log(response);

      if(response.total!== totalElements){
        setPage(1)
      }
      console.log("todas", response.products.filter(x => x.product.card_id !== x.product.name));

      setInventary(response.products);
      searchInventary(response.products);
      // searchInventary(response.products)

      setTotalPage(response.last_page)
      setTotalElements(response.total)
      //calculateAllInventaryTotalPrice(response.products);
      setLoading(false);
    }
    catch(error:any){
      setLoading(false);
      console.log(error)
      if(error?.response?.data?.message==="Catalogo no disponible"){
        setErrorView("bloqued")
        sendError({type: "ERROR", data:{message:"El catálogo esté deshabilitado y estará disponible con nuevas cartas pronto.", type:"info"}})

      }
      else{
      sendError({type: "ERROR", data:{message:"Error al cargar el inventario.", type:"error"}})

      }

    }
  }

  const searchAllCards = async () => {
    try{
      if(nameCards==="") return;
      setLoading(true);
      const response = await getAllCards(nameCards, "");
      setAllCards(response);
      setLoading(false);
    }
    catch(error){
      setLoading(false);
      sendError({type: "ERROR", data:{message:"Error al cargar el inventario", type:"error"}})

    }
  }


  const getCards =async()=>{
    try{
      setLoading(true);
      const response = await getAllCards("", setID!);
      setAllCards(response);
      setLoading(false);
    }
    catch(error){
      setLoading(false);
      sendError({type: "ERROR", data:{message:"Error al cargar el inventario", type:"error"}})

    }
  }

  useEffect(() => {

    if(type==="inventary" ){
      getAllInventary();
    }

    if(type==="cards"&& setID){
      getCards()
    }

  }, []);

    useEffect(() => {
    if(type==="inventary"){
      searchInventary(inventary);
    }


  }, [nameCards, selectedSets, selectedTypes]);

  const searchInventary = async (inventaryFilter:Inventary[]) => {
    let inventaryFilterGuard = inventaryFilter
    setPage(1)

    if(nameCards===""){
      // setFilterInventary(inventaryFilter);
      // return;
      inventaryFilterGuard = inventaryFilter
    }
    else{
      inventaryFilterGuard = inventaryFilter.filter((inventaryUnit) => {
        if(inventaryUnit.product.pokemonCard.length>0){
          if(inventaryUnit.product.pokemonCard[0].name.toUpperCase().includes(nameCards.toUpperCase())){
            return true;
          }
        }
      })
    }

    if(selectedSets.length>0){
      inventaryFilterGuard = inventaryFilterGuard.filter(inventaryUnit => selectedSets.includes(inventaryUnit.product.pokemonCard[0].setId) )
    }

    if(selectedTypes.length>0){

      if(selectedTypes.includes("Trainer")){
        inventaryFilterGuard = inventaryFilterGuard.filter(inventaryUnit => selectedTypes.includes(inventaryUnit.product.pokemonCard[0].supertype) )
        inventaryFilterGuard = inventaryFilterGuard.filter(inventaryUnit => inventaryUnit.product.pokemonCard[0].subtypes.includes("Supporter") )
      }
      else{
        inventaryFilterGuard = inventaryFilterGuard.filter(inventaryUnit => selectedTypes.includes(inventaryUnit.product.pokemonCard[0].rarity) )

      }

    }

    console.log("filter ", inventaryFilterGuard)
    setFilterInventary(inventaryFilterGuard);
  }

        const sendMonitor = async (pagina:number)=>{
          try  
          {let user:string= localStorage.getItem("user") || ""
  
            let monitor:Monitor={
                action:`Cambio de pagina en Cartas: Pagina ${pagina}`,
                user:user
            }
            await addMonitor(monitor)}
            catch(error){}
        }

  return (
    <>


    { errorView==="bloqued" ? <NewCardsCountdown />:



    <div className='ListCardAdminComponent'>
        <FilterSectionPokemon
        loading={loading} 
        type={type} 
        nameCard={nameCards} 
        selectedSets={selectedSets}
        setSelectedSets={setSelectedSets}
        selectedTypes={selectedTypes}
        setSelectedTypes={setSelectedTypes}
        setNameCard={setNameCard}
        searchFunction={searchAllCards} />

        <div className='ListCardSection'>

            {type==="inventary" &&

            <>
              <SkeletonCart loading={loading}>


              {filterInventary?.slice((page - 1) * sizePages, page * sizePages).map((inventaryUnit, index) => {
                if(inventaryUnit.product.pokemonCard.length>0){
                  return <CardAdminComponentPokemon
                          language={inventaryUnit.product.language}
                          elementClass={elementClass} 
                          hasQty={hasQty} 
                          price={inventaryUnit.product.price} 
                          qtyFunction={qtyFunction} 
                          hasPrice={hasPrice} 
                          key={inventaryUnit.product.pokemonCard[0].id + index} 
                          inventary={inventaryUnit}
                          maxQty={inventaryUnit.quantity}
                          card={inventaryUnit.product.pokemonCard[0]} 
                          hasCart={hasCart}
                          type={inventaryUnit.product.card_type}
                          onClickIventary={onClickIventary} />

                }
              })}
              
              </SkeletonCart>
            
            </>
            }

            {type==="all" &&
            <>
            {loading && <Spin />}
              {allCards.map((card, index) => {
                  return <CardAdminComponentPokemon 
                          elementClass={elementClass} 
                          hasQty={hasQty} 
                          priceString={``} 
                          qtyFunction={qtyFunction} 
                          hasPrice={hasPrice} 
                          key={card.id} 
                          maxQty={0}
                          card={card}
                          type=''

                          onClick={onClick}  />

              })}
            
            </>
            }

            {type==="cards" &&
            <>
            <SkeletonCart loading={loading}>
              {allCards.map((card, index) => {
                  return <CardAdminComponentPokemon 
                          elementClass={elementClass} 
                          hasQty={hasQty} 
                          priceString={``} 
                          qtyFunction={qtyFunction} 
                          hasPrice={hasPrice} 
                          key={card.id} 
                          maxQty={0}
                          card={card}
                          type=''
                          onClick={onClick}  />

              })}
              </SkeletonCart>
            
            </>
            }



        </div>

        {/* <div className='centerPaginate'>
            {(totalPage>1 && !loading) && <Pagination defaultCurrent={page} onChange={(newPage, newPageSize)=>{sendMonitor(newPage);setPage(newPage);window.scrollTo({ top: 0, behavior: 'smooth' });}} current={page} total={totalElements} pageSize={limitPage} showSizeChanger={false} />}
        </div> */}

          <div className='centerPaginate'>
            {filterInventary?.length >sizePages && <Pagination defaultCurrent={1} onChange={(newPage, newPageSize)=>{setPage(newPage);window.scrollTo({ top: 0, behavior: 'smooth' });}} current={page} total={filterInventary?.length} pageSize={sizePages} showSizeChanger={false} />}
        </div>
    </div>
    }

  </>
  )
}

export default ListCardAdminComponentPokemon